/* global __BUILD_CONFIG__ */
console.log(__BUILD_CONFIG__)

export default {
  APP_VERSION: '0.1.0',

  // do not forget authToken on page reload (for development)
  // KEEP_LOGGED_IN: process.env.NODE_ENV === 'development',
  KEEP_LOGGED_IN: true,

  ...((__BUILD_CONFIG__ === 'development') ? require('./dev').default : {}),
  ...((__BUILD_CONFIG__ === 'production') ? require('./prod').default : {}),
}
